import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import RegionalFocus from './components/RegionalFocus';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function HomePage() {
  return (
    <>
      <SEOHead />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <RegionalFocus />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
}
